import React from 'react'

import './Layout.scss'

export interface LayoutPropsInterface {
  style?: React.CSSProperties
}

export const Layout: React.FC<LayoutPropsInterface> = ({ style, children }) => {
  return (
    <div style={style} className="Controlled Layout">
      {children}
    </div>
  )
}

export const LayoutColumn: React.FC<LayoutPropsInterface> = ({ style, children }) => {
  return (
    <div style={style} className="Controlled LayoutColumn">
      {children}
    </div>
  )
}
